module.exports = __webpack_public_path__ + "static/media/Onion.a66d391e.webp";